import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/accountStore.js'), 'accountStore.js')
  resolveStoreModules(require('../store/adventsStore.js'), 'adventsStore.js')
  resolveStoreModules(require('../store/alertStore.js'), 'alertStore.js')
  resolveStoreModules(require('../store/analyticsStore.js'), 'analyticsStore.js')
  resolveStoreModules(require('../store/bannerStore.js'), 'bannerStore.js')
  resolveStoreModules(require('../store/camStore.js'), 'camStore.js')
  resolveStoreModules(require('../store/deviceStore.js'), 'deviceStore.js')
  resolveStoreModules(require('../store/dropdownStore.js'), 'dropdownStore.js')
  resolveStoreModules(require('../store/epgStore.js'), 'epgStore.js')
  resolveStoreModules(require('../store/filtersStore.js'), 'filtersStore.js')
  resolveStoreModules(require('../store/formStore.js'), 'formStore.js')
  resolveStoreModules(require('../store/loadstateStore.js'), 'loadstateStore.js')
  resolveStoreModules(require('../store/modalStore.js'), 'modalStore.js')
  resolveStoreModules(require('../store/mxmStore.js'), 'mxmStore.js')
  resolveStoreModules(require('../store/notificationStore.js'), 'notificationStore.js')
  resolveStoreModules(require('../store/pagesStore.js'), 'pagesStore.js')
  resolveStoreModules(require('../store/paywallStore.js'), 'paywallStore.js')
  resolveStoreModules(require('../store/popunderStore.js'), 'popunderStore.js')
  resolveStoreModules(require('../store/ppmStore.js'), 'ppmStore.js')
  resolveStoreModules(require('../store/resourcesStore.js'), 'resourcesStore.js')
  resolveStoreModules(require('../store/scrollStore.js'), 'scrollStore.js')
  resolveStoreModules(require('../store/searchStore.js'), 'searchStore.js')
  resolveStoreModules(require('../store/slideStore.js'), 'slideStore.js')
  resolveStoreModules(require('../store/subscriptionsStore.js'), 'subscriptionsStore.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
